<style scoped lang="scss" type="text/scss">
.player-application-container {
    .info-panel {
        margin-bottom: 1rem;
    }
}
</style>

<template>
    <div class="player-application-container">
        <info-panel class="info-panel">批准成功后，该队伍会成为对应届比赛的参赛队，并进行后续报名流程</info-panel>
        <div class="global-relative">
            <loading-placeholder :loading="loadingRequesting"></loading-placeholder>
            <el-table :data="playerApplications" stripe border size="small" style="width: 100%">
                <el-table-column type="index" :index="indexMethod" label="序号" align="center"
                                 width="80"></el-table-column>
                <el-table-column prop="competition_name" label="赛事名称" align="center"
                                 min-width="180"></el-table-column>
                <el-table-column prop="competition_year_text" label="赛事年份" align="center"
                                 min-width="70"></el-table-column>
                <el-table-column prop="school_name" label="学校名称" align="center" min-width="180"></el-table-column>
                <el-table-column prop="team_name" label="队伍名称" align="center" min-width="200"></el-table-column>
                <el-table-column prop="student_leader_name" label="指定学生队长" align="center"
                                 min-width="100"></el-table-column>
                <el-table-column prop="max_school_player_number" label="当前队伍数量（包含未审批）与限制" align="center"
                                 min-width="100">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.max_school_player_number.includes('>') ? 'red' : 'black'}">
                            {{ scope.row.max_school_player_number }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time_text" label="申请时间" align="center" width="140"></el-table-column>
                <el-table-column label="操作" width="170" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="approve(scope.row)"
                                   :loading="scope.row.id === requestingId && approveRequesting">批准
                        </el-button>
                        <el-button size="mini" type="danger" plain @click="reject(scope.row)"
                                   :loading="scope.row.id === requestingId && rejectRequesting">驳回
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="确认驳回？" :visible.sync="dialogVisible" width="30%">
                <el-form ref="form" :model="rejectData" label-width="80px">
                    <el-form-item label-width="200px" label="请输入驳回理由（ 可选 ）">
                        <el-select clearable filterable allow-create v-model="rejectData.selectedValue" placeholder="请选择">
                            <el-option
                                v-for="option in options"
                                :key="option.value"
                                :label="option.value"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmSelection">确定</el-button>
                </span>
            </el-dialog>
            <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                        @current-change="loadUnfinishedPlayerApplications">
            </pagination>
        </div>
    </div>
</template>

<script>
import InfoPanel from '../../../../../components/info-panel/index';
import {handlePlayerApplications} from '../../../../../utils/data-handler';
import {indexMethod, updatePageOption} from '../../../../../utils/page';
import th from "element-ui/src/locale/lang/th";

export default {
    name: '',
    components: {
        InfoPanel
    },
    created() {
        this.loadUnfinishedPlayerApplications();
    },
    data() {
        return {
            playerApplications: [],
            dialogVisible: false,
            rejectData: {
                selectedValue: ""
            },
            // rejectPlayerApplicationData: "",
            options : [
                {value: "参数数量超过限制"},
                {value: "参赛届数不符合"},
            ],
            requestingId: null,
            loadingRequesting: false,
            approveRequesting: false,
            rejectRequesting: false,
            pageSize: 10,
            total: 0,
            currentPage: 1
        };
    },
    computed: {
        page() {
            return {
                page_size: this.pageSize,
                page_num: this.currentPage
            };
        }
    },
    methods: {
        indexMethod(index) {
            return indexMethod(index, this);
        },
        loadUnfinishedPlayerApplications() {
            this.$normalRequest('competition/loadUnfinishedPlayerApplications', {
                ...this.page
            }, false, false, this, 'loadingRequesting').then(data => {
                updatePageOption(this, data);
                this.playerApplications = handlePlayerApplications(data.list);
            }).catch(_ => {
            });
        },
        approve(data) {
            const playerApplicationId = data.id;
            this.requestingId = playerApplicationId;
            this.$normalConfirm('确认批准？', '批准操作无法撤回，请谨慎操作').then(_ => {
                this.$normalRequest('competition/approvePlayer', {id: playerApplicationId}, '已完成批准操作', true, this, 'approveRequesting').then(_ => {
                    this.loadUnfinishedPlayerApplications();
                }).catch(_ => {
                });
            }).catch(_ => {
            });
        },
        confirmSelection() {
            this.dialogVisible = false;
            // const playerApplicationId = this.rejectPlayerApplicationData.id;
            // this.requestingId = playerApplicationId;
            this.$normalRequest('competition/rejectPlayer', {
                id: this.requestingId,
                reason: this.rejectData.selectedValue
            }, '已完成驳回操作', true, this, 'rejectRequesting').then(_ => {
                this.loadUnfinishedPlayerApplications();
            }).catch(_ => {
            });
        },
        reject(data) {
            this.dialogVisible = true;
            if (data.id == null || data.id.length === 0) {
                this.requestingId = ""
            } else {
                this.requestingId = data.id
            }
        }
    }
};
</script>
